import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for individual curriculum pages
 * Renders child routes (detail, edit) via Outlet
 */
function CurriculumIdLayout() {
  return <Outlet />;
}

export const Route = createFileRoute('/app/curriculum/$curriculumId')({
  component: CurriculumIdLayout,
});
